import { routes } from "~/router";

// The Orders tabs, by the type the orders are listed by.
export type OrdersTab = "links" | "concierge";

export const ORDERS_TAB_PARAM = "tab";

export const parseOrdersTab = (value: string | null): OrdersTab =>
  value === "concierge" ? "concierge" : "links";

export const ordersTabFor = (serviceType: string): OrdersTab =>
  serviceType === "concierge" ? "concierge" : "links";

export const ordersTabPath = (tab: OrdersTab) =>
  `${routes.services.orders()}?${ORDERS_TAB_PARAM}=${tab}`;
